import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/lukas/Sites/git/own-packages/react-i18n-kit/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Translator } from "./components";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Translator heading page="installation" num="0" mdxType="Translator" />
    <Translator page="installation" num="0" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`$ npm i react-i18n-kit -S
`}</code></pre>
    <Translator page="installation" num="1" mdxType="Translator" />
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`$ yarn add react-i18n-kit
`}</code></pre>
    <Translator page="installation" num="2" mdxType="Translator" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      